var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"progress-bar",attrs:{"width":_vm.width,"height":_vm.height}},[_c('rect',{staticClass:"bg",attrs:{"x":"0","y":"0","height":_vm.height,"width":_vm.width,"rx":"5","ry":"5"}}),_c('rect',{attrs:{"x":"0","y":"0","height":_vm.height,"width":_vm.barWidth,"rx":"5","ry":"5","fill":_vm.PAGE_COLORS[_vm.$route.name].cl}})])
}
var staticRenderFns = []

export { render, staticRenderFns }